import { render } from "./ProductionTable.vue?vue&type=template&id=3a7d5248&scoped=true&ts=true&lang=pug"
import script from "./ProductionTable.vue?vue&type=script&lang=ts"
export * from "./ProductionTable.vue?vue&type=script&lang=ts"

import "./ProductionTable.vue?vue&type=style&index=0&id=3a7d5248&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7d5248"]])

export default __exports__